import { COLORS } from '@/constants';
import styled, { keyframes } from 'styled-components';
import CachedIcon from '@mui/icons-material/Cached';
import { Button } from '@mui/material';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  padding-bottom: 6px;
`;

export const MainBlockWrapper = styled.div`
  display: flex;
  gap: 13px;
  align-items: flex-start;
  padding-bottom: 12px;
  width: 100%;
`;

export const ImageWrapper = styled.div`
  height: 106px;
  width: 96px;
  border: 1px solid ${COLORS['neutral/300']};
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;

  img {
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
`;

export const InfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const InfoTextBox = styled.div`
  display: flex;
  gap: 6px;
  padding-bottom: 6px;
  align-items: center;

  &:last-child {
    padding-bottom: 0;
  }

  img {
    width: 16px;
    height: 16px;
    object-fit: contain;
    object-position: center;
  }
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-repeat: no-repeat;
`;

export const ButtonsBox = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  flex-direction: column;
`;

export const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const SpinningIcon = styled(CachedIcon)`
  animation: ${spin} 1.5s linear infinite;
`;

export const StyledButton = styled(Button)`
  && {
    height: 24px;
    align-self: flex-end;
    margin-top: -2px;
    text-transform: none;
  }
`;

export const AgentStyledButton = styled(Button)`
  && {
    width: 100%;
    height: 32px;
    background: transparent;
  }
`;
